// extracted by mini-css-extract-plugin
export var deleteIcon = "_sx-5";
export var deleteOption = "_sx-3";
export var divider = "_sx-2";
export var downloadIcon = "_sx-4";
export var drawer = "_sx-0";
export var drawerFooter = "_sx-6";
export var drawerOpen = "_sx-1";
export var highlighted = "_sx-7";
export var lighterHighlight = "_sx-8";